<template>
  <div>
    <v-dialog v-model="login" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Admin Login</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  class="rounded-xl"
                  v-model="username"
                  label="Username/Email"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  class="rounded-xl"
                  v-model="password"
                  label="Password"
                  required
                  type="password"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  class="rounded-xl"
                  v-model="totp"
                  label="2FA"
                  required
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn class="rounded-xl" text @click="login = false"> Close</v-btn>
          <v-btn
            class="rounded-xl"
            :loading="loading"
            color="info"
            text
            @click="doLogin()"
          >
            Login
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <h1>We're under maintenance</h1>
            <p>Please check back soon.<br />Join our Discord for updates.</p>
            <v-chip color="#7289DA" href="https://discord.gg/ZkCJ7rjrme">
              <v-icon>mdi-discord</v-icon>&nbsp;Discord </v-chip
            >&nbsp;
            <v-chip @click="login = true">
              <v-icon>mdi-login</v-icon>&nbsp;Admin Login
            </v-chip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "Maintenance",
  data() {
    return {
      login: false,
      username: "",
      password: "",
      totp: "",
      loading: false
    }
  },
  methods: {
    doLogin() {
      this.loading = true
      this.axios
        .post("/api/v1/auth/login", {
          email: this.username,
          password: this.password,
          code: this.totpCode
        })
        .then((res) => {
          this.loading = false
          this.$store.commit("login", res.data)
          Object.assign(this.axios.defaults, {
            headers: { Authorization: this.$store.state.user.token }
          })
          this.axios
            .get("/api/v1/userutils/info")
            .then((res) => {
              this.$store.commit("login", res.data)
              this.$router.push("/")
              this.getUserData()
              this.$toast("You have been logged in.", {
                timeout: 3000,
                type: "success"
              })
            })
            .catch((e) => {
              AjaxErrorHandler(this.$store)(e)
            })
        })
        .catch((e) => {
          if (e.response.data.errors[0].name === "remoteSSOProvider") {
            window.location.href =
              "https://sso.flowinity.com/auth/realms/master/protocol/openid-connect/auth?client_id=" +
              this.$store.state.site.flowinityId +
              "&redirect_uri=" +
              this.$store.state.site.hostnameWithProtocol +
              "%2FflowinityAuthorize%2Flogin&response_type=code"
          }
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    }
  }
}
</script>

<style scoped></style>
